import script from "./DepositPaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositPaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./DepositPaymentMethod.vue?vue&type=style&index=0&id=7583c91e&scoped=true&lang=css"
import "./DepositPaymentMethod.vue?vue&type=style&index=1&id=7583c91e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7583c91e"]])

export default __exports__